var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--icon-color)",
    height: "800px",
    width: "800px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,19h-4.5c-0.3,0-0.5-0.1-0.7-0.3L16,10.5l-7.8,8.2C8,18.9,7.8,19,7.5,19H3c-0.4,0-0.8-0.2-0.9-0.6 C1.9,18,2,17.6,2.3,17.3l13-14c0.4-0.4,1.1-0.4,1.5,0l13,14c0.3,0.3,0.3,0.7,0.2,1.1C29.8,18.8,29.4,19,29,19z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,21c-0.8,0-1.6-0.3-2.2-0.9L16,13.4l-6.3,6.7C9.1,20.7,8.3,21,7.5,21H6v7c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1v-7H24.5z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.e68c8b1d70e6423af6f8e54c2c23cce7.svg";
export { ForwardRef as ReactComponent };